import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { Title } from 'components/layout'
import { FormData, Button } from 'components/misc'
import { FormattedDate } from 'components/intl'

export default class ParticipantRegistrationDetailModal extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    modal: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
  }

  static defaultProps = {
    data: {}
  }

  render() {
    const { modalId, data } = this.props

    return (
      <Modal id={modalId} customActions>
        <Title h2 intlKey="moduleTitle.participant_registration">
          Registration Detail
        </Title>
        <div className="row">
          <div className="col-xs-6">
            <FormData label="First Name" intlKey="label.first_name">
              {get(data, 'firstName')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Last Name" intlKey="label.last_name">
              {get(data, 'lastName')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Email" intlKey="label.email">
              {get(data, 'email')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Birthday" intlKey="label.birthdate">
              {get(data, 'birthDate') ? (
                <FormattedDate value={data.birthDate} />
              ) : (
                '---'
              )}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Gender" intlKey="label.gender">
              {get(data, 'gender.translationText') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Nationality" intlKey="label.nationality">
              {get(data, 'nationality.translationText') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Phone" intlKey="label.phone">
              {get(data, 'phoneNumber')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Phone type" intlKey="label.phone_type">
              {get(data, 'phoneType.translationText')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Employment Status" intlKey="label.employment_status">
              {get(data, 'employmentStatus.translationText') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Organization" intlKey="label.organization">
              {get(data, 'organizationName')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Award Level" intlKey="label.award_level">
              {get(data, 'awardLevel.translationText')}
            </FormData>
          </div>
        </div>

        <Title h2 intlKey="moduleTitle.participant_registration">
          Parent
        </Title>
        <div className="row">
          <div className="col-xs-6">
            <FormData label="First Name" intlKey="label.first_name">
              {get(data, 'parentFirstName')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Last Name" intlKey="label.last_name">
              {get(data, 'parentLastName')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Email" intlKey="label.email">
              {get(data, 'parentEmail')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Phone" intlKey="label.phone">
              {get(data, 'parentPhone')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Relationship" intlKey="label.relationship">
              {get(data, 'parentRelationship')}
            </FormData>
          </div>
        </div>

        <Title h2 intlKey="moduleTitle.address">
          Address
        </Title>

        <div className="row">
          <div className="col-xs-6">
            <FormData label="Address Line 1" intlKey="label.addressLine1">
              {get(data, 'line1') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="City" intlKey="label.city">
              {get(data, 'city') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Address Line 2" intlKey="label.addressLine2">
              {get(data, 'line2') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Post Code" intlKey="label.post_code">
              {get(data, 'zipCode') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Address Line 2" intlKey="label.state_province">
              {get(data, 'stateOrProvinceOrRegion') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Post Code" intlKey="label.country">
              {get(data, 'country.name') || '---'}
            </FormData>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text--right">
            <Button
              type="button"
              intlKey="button.close"
              onClick={() => this.props.modal(null)}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}
